import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import TimelineIcon from "@material-ui/icons/Timeline";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    // backgroundColor: "cornflowerblue",
    backgroundColor: "white",
    top: "0",
    width: "100%",
    display: "block",
    transition: "top 0.3s",
    margin: "0",
    padding: "0",
  },
  toolbar: {},
  toolbarTitle: {
    flex: 1,
  },
}));

export default function LandingPageHeader({ NavButton }) {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <CssBaseline />
      <AppBar
        position="absolute"
        color="default"
        className={classes.appBar}
        m={2}
      >
        <Toolbar className={classes.toolbar}>
          <Typography
            component="h2"
            variant="h5"
            color="inherit"
            align="left"
            noWrap
            className={classes.toolbarTitle}
          >
            <Button
              href="#"
              style={{ color: "rgb(22, 177, 255)" }}
              startIcon={<TimelineIcon />}
            >
              AIMS
            </Button>
          </Typography>
          {NavButton === "Home" && (
            <>
              <Button
                variant="text"
                onClick={() => history.push("/ourTeam")}
                size="small"
              >
                Our Team
              </Button>
              <Button
                variant="text"
                onClick={() => history.push("/about")}
                size="small"
              >
                About
              </Button>
              <Button onClick={() => history.push("/pricing")} size="small">
                Pricing
              </Button>
              {/* <Button onClick={()=>history.push('/signIn')} size="small">
                Sign In
              </Button> */}
            </>
          )}
          {NavButton === "signin" && (
            <>
              <Button
                variant="text"
                onClick={() => history.push("/ourTeam")}
                size="small"
              >
                Our Team
              </Button>
              <Button
                variant="text"
                onClick={() => history.push("/about")}
                size="small"
              >
                About
              </Button>
              <Button onClick={() => history.push("/pricing")} size="small">
                Pricing
              </Button>
              {/* <Button onClick={()=>history.push('/signIn')} size="small">
                Sign In
              </Button> */}
            </>
          )}
          {(NavButton === "ourteam" || NavButton === "about") && (
            <>
              <Button
                variant="text"
                onClick={() => history.push("/ourTeam")}
                size="small"
              >
                Our Team
              </Button>
              <Button
                variant="text"
                onClick={() => history.push("/about")}
                size="small"
              >
                About
              </Button>
              <Button onClick={() => history.push("/pricing")} size="small">
                Pricing
              </Button>
              <Button onClick={() => history.push("/")} size="small">
                Home
              </Button>
            </>
          )}
          {NavButton === "Pricing" && (
            <>
              <Button
                variant="text"
                onClick={() => history.push("/ourTeam")}
                size="small"
              >
                Our Team
              </Button>
              <Button
                variant="text"
                onClick={() => history.push("/about")}
                size="small"
              >
                About
              </Button>
              <Button onClick={() => history.push("/signIn")} size="small">
                Sign In
              </Button>
              {/* <Button onClick={()=>history.push("/")} size="small">
                Home
              </Button> */}
            </>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
}
